import routes from '@/config/routes';
import { v3Get, v3Put, v3Remove } from '@/api/axios.instance.V3';
import type { ApiResponse } from '../types';
import type { IFraudGrpOption } from '@/store/admin/types/types';

const getFraudReviewGrpsList = (): ApiResponse => v3Get(routes.backendUrl.fraudGrp.getFraudcheckgroup);

const updateFraudReviewGroup = (payload: IFraudGrpOption): ApiResponse => {
  return v3Put(routes.backendUrl.fraudGrp.updateFraudGroup, payload);
};

const deleteUser = (fraudCheckGroupId: number, userId: number): ApiResponse =>
  v3Remove(`${routes.backendUrl.fraudGrp.deleteUser}/${fraudCheckGroupId}/${userId}`);

const getUsersList = (fraudCheckGroupId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.fraudGrp.usersList.replace('{fraudCheckGroupId}', fraudCheckGroupId.toString())}`);

const getFraudGroupList = (userId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.fraudGrp.fraudGroupList}/${userId}`);

const getSessionLogsList = (userId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.fraudGrp.getSessionLogsList}/${userId}`);

export const adminFraudReviewGrpApi = {
  getFraudReviewGrpsList,
  updateFraudReviewGroup,
  deleteUser,
  getUsersList,
  getFraudGroupList,
  getSessionLogsList,
};
